import {
  FaEdit,
  FaTrash,
  FaLock,
  FaUnlock,
} from "react-icons/fa";

export default function ProductoTable({
  productos,
  loading,
  onEditar,
  onEliminar,
  onToggleEstado,
}) {
  return (
    <div className="mt-2 rounded-xl border border-slate-200 dark:border-slate-800">
      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[750px] text-sm">
          <thead className="bg-slate-100 dark:bg-slate-950/80">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-left">Nombre</th>
              <th className="px-4 py-2 text-center">Categoría</th>
              <th className="px-4 py-2 text-center">Precio</th>
              <th className="px-4 py-2 text-center">Estado</th>
              <th className="px-4 py-2 text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            {productos.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-4 text-center">
                  {loading
                    ? "Cargando productos..."
                    : "No se encontraron productos"}
                </td>
              </tr>
            ) : (
              productos.map((p) => (
                <tr
                  key={p.id}
                  className="odd:bg-white even:bg-slate-50
                             dark:odd:bg-slate-900/60 dark:even:bg-slate-900/40
                             hover:bg-slate-100 dark:hover:bg-slate-800"
                >
                  <td className="px-4 py-2">{p.id}</td>

                  <td className="px-4 py-2 font-medium">{p.nombre}</td>

                  <td className="px-4 py-2 text-center">
                    {p.categoria?.nombre || "—"}
                  </td>

                  <td className="px-4 py-2 text-center font-semibold">
                    ${Number(p.precio).toFixed(2)}
                  </td>

                  <td className="px-4 py-2 text-center">
                    {!p.bloqueado ? (
                      <span className="text-emerald-500">🟢 Disponible</span>
                    ) : (
                      <span className="text-rose-400">🔴 Bloqueado</span>
                    )}
                  </td>

                  <td className="px-4 py-2 text-center">
                    <div className="flex flex-wrap justify-center gap-2">
                      <button
                        onClick={() => onEditar(p)}
                        className="inline-flex items-center gap-2 px-3 py-1.5
                                   rounded-lg text-xs font-medium
                                   border border-sky-500 text-sky-300
                                   hover:bg-sky-500 hover:text-slate-900"
                      >
                        <FaEdit />
                        Editar
                      </button>

                      <button
                        onClick={() => onToggleEstado(p)}
                        className={`inline-flex items-center gap-2 px-3 py-1.5
                                   rounded-lg text-xs font-medium border transition-colors ${
                          !p.bloqueado
                            ? "border-amber-500 text-amber-300 hover:bg-amber-500 hover:text-slate-900"
                            : "border-emerald-500 text-emerald-300 hover:bg-emerald-500 hover:text-slate-900"
                        }`}
                      >
                        {!p.bloqueado ? <FaLock /> : <FaUnlock />}
                        {!p.bloqueado ? "Bloquear" : "Desbloquear"}
                      </button>

                      <button
                        onClick={() => onEliminar(p.id)}
                        className="inline-flex items-center gap-2 px-3 py-1.5
                                   rounded-lg text-xs font-medium
                                   border border-rose-500 text-rose-300
                                   hover:bg-rose-500 hover:text-slate-900"
                      >
                        <FaTrash />
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
